import React, { useLayoutEffect, useRef, useState } from "react";

const FitText = ({
  children,
  maxFontSize = 24,
  minFontSize = 10,
  style = {},
  className = "",
}) => {
  const ref = useRef();
  const [fontSize, setFontSize] = useState(maxFontSize);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    const parent = el.parentElement;
    if (!parent) return;

    // Step 1: 折り返しを防止して、widthにフィットさせる
    el.style.whiteSpace = "nowrap";
    let size = maxFontSize;
    el.style.fontSize = `${size}px`;

    while (el.scrollWidth > parent.clientWidth && size > minFontSize) {
      size -= 1;
      el.style.fontSize = `${size}px`;
    }

    // Step 2: 折り返しを許可して再レンダリング後に判定
    el.style.whiteSpace = "normal";

    // 次のフレームで折り返しを確認
    requestAnimationFrame(() => {
      if (!el || !parent) return;

      const isWrapped = el.scrollHeight > parent.clientHeight + 1;
      if (isWrapped) {
        const halfHeight = Math.floor(parent.clientHeight / 2);
        const adjustedSize = Math.max(minFontSize, halfHeight);
        el.style.fontSize = `${adjustedSize}px`;
        setFontSize(adjustedSize);
      } else {
        setFontSize(size); // 折り返していないなら最初に計算したサイズ
      }
    });
  }, [children, maxFontSize, minFontSize]);

  return (
    <div
      ref={ref}
      className={className}
      style={{ ...style, fontSize }}
    >
      {children}
    </div>
  );
};

export default FitText;
